<template>
	<fragment>
		<common-header
			subname="설문 관리"
			name="새 설문 작성"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu></common-side-menu>

			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">설문 관리</div>
					<div class="pull-right p-10">
						<button class="btn-sm bg-deepblue text-white round" @click="modals.ModalSurveyAppend.show=true">문항추가</button>
					</div>
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">
								설문명 <input class="form-control round f-18 text-blue text-left m-b-0 w400" type="text" style="float: none;" v-model="data.surveyName" autocomplete="off">
								<span class="f-12 text-nomal text-lightgray">{{data.surveyName.length}} / 30</span>
							</p>
							<p class="f-18 m-t-10 m-b-0 text-bold text-blue">
								설문대상 <select v-model="data.target">
									<option value="수강생">수강생</option>
									<option value="비회원">수강생+비회원</option>
								</select>
							</p>
							<p class="f-18 m-t-10 m-b-0 text-bold text-blue">
								응답기간 :
								<VueCtkDateTimePicker v-model="data.surveyStart" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.surveyStart" autcomplete="off">
								</VueCtkDateTimePicker>
								<VueCtkDateTimePicker v-model="data.surveyEnd" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.surveyEnd" autcomplete="off">
								</VueCtkDateTimePicker>
							</p>
						</span>
					</div>
					<textarea class="full-width m-t-15 v-mid" cols="30" rows="10" placeholder="설문 설명" v-model="data.info"></textarea>
					<span class="f-12 text-nomal pull-right text-lightgray">{{data.info.length}} / 500</span>
				</div>


				<div class="white-box clearfix" v-for="(item, surveyItemIdx) in data.surveyItemList" :item="item" :index="surveyItemIdx" :key="'classroom-survey-'+surveyItemIdx+hash(item)">
					<div class="input-group full-width m-b-30 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">{{surveyItemIdx+1}}.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							<select class="form-control-sm full-width round m-b-0" v-model="item.type" readonly>
								<option>객관식</option>
								<option>주관식</option>
							</select>
						</span>
						<span class="input-group-addon p-r-5">
							<input class="form-control-sm full-width text-left round m-b-0" type="text" v-model="item.itemName" readonly>
						</span>
						<span class="input-group-addon w120 v-mid">
							<button class="btn-sm btn-red round" @click="data.surveyItemList.splice(surveyItemIdx,1)">문항제거</button>
						</span>
					</div>
				</div>
				<div class="b-t p-15 p-l-0 m-t-30 m-b-30 clearfix">
					<button class="btn pull-right round w160" @click="modals.ModalSurveyAppend.show=true">문항추가</button>
				</div>
			</div>
		</section>

		<modal-survey-append :config="modals.ModalSurveyAppend" @close="modals.ModalSurveyAppend.show=false;" :key="hash(modals.ModalSurveyAppend)" @append="append" @alert="alert"></modal-survey-append>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import ModalSurveyAppend from '../modals/ModalSurveyAppend.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import axios from 'axios'
import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewSurveyRegister',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		VueCtkDateTimePicker,
		ModalSurveyAppend,
		ModalAlert
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'설문 관리',link:"/surveys",selected:true},
				{name:'설문문항 관리',link:"/surveyItems",selected:false},
				{name:'설문 분류',link:"/surveys/categories",selected:false},
				{name:'설문 통계',link:"/surveys/statistics",selected:false},
			],
			buttons : [
				{name:'저장하기', fn:this.register}
			],
			modals: {
				ModalSurveyAppend: ModalSurveyAppend.default(),
				ModalAlert: ModalAlert.default(),
			},
			lecture: {},
			curriculum: {},
			data: {
				surveyName: "",
				surveyStart: "",
				surveyEnd: "",
				target: "수강생",
				info: "",
				questCount: 0,
				surveyItemList: [],
				surveyItemMappingList: []
			}
		}
	},


	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		append: function(items) {
			this.data.surveyItemList = [...this.data.surveyItemList, ...items];
			this.data.surveyItemMappingList = [...this.data.surveyItemMappingList, ...items.map(i=>{return {surveyItemId:i.surveyItemId}})]
			this.data.questCount = this.data.surveyItemList.length;
		},
		alert: function(msg) {
			this.modals.ModalAlert.msg = msg;
			this.modals.ModalAlert.show = true;
		},
		register: function() {
			axios.put(server.addr()+"/survey", [this.data]).then(() => {
				this.$router.push('/surveys');
			})
		}
	}
}
</script>
